import styled from 'styled-components';
import type { MediaImageProps } from '@elfsight/widget-media';
import { MediaImage } from '@elfsight/widget-media';

interface LogoContainerProps extends MediaImageProps {
  withCover: boolean;
  cardWidth?: number;
  isPopup?: boolean;
}

export const LogoContainer = ({
  src,
  alt,
  withCover,
  cardWidth,
  isPopup
}: LogoContainerProps) => {
  if (!src) {
    return null;
  }

  return (
    <Logo _withCover={withCover} _cardWidth={cardWidth} _isPopup={isPopup}>
      <MediaImage src={src} alt={alt} mode="contain" />
    </Logo>
  );
};

type LogoStyledProps = {
  _withCover: boolean;
  _cardWidth?: number;
  _isPopup?: boolean;
};

const Logo = styled.div<LogoStyledProps>`
  background-color: #fff;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  margin-right: 12px;
  width: 50px;
  height: 50px;
  flex-shrink: 0;
  flex-grow: 0;

  ${(props) =>
    isOffsetLogo(props) &&
    `
     margin-bottom: 12px;
     margin-top: -40px;
  `}
`;

export const isOffsetLogo = ({
  _withCover,
  _isPopup,
  _cardWidth
}: LogoStyledProps) => {
  return _withCover && (_isPopup || Number(_cardWidth) < 800);
};
